import { collection, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../firebase";

export type BoardMember = {
  id?: string;
  name: string;
  role: string;
  bio?: string;
  imageUrl?: string;
  email?: string;
  sortOrder?: number;
  isPublished?: boolean;
};

const fallbackBoard: BoardMember[] = [
    { name: "Josh Fink", role: "President" },
    { name: "Beth Jabs", role: "Vice President & Parliamentarian" },
    { name: "Ben Erb", role: "Treasurer" },
    { name: "Andi Brown", role: "Secretary" },
    { name: "Willis Hunt", role: "Member" },
    { name: "Dustin Peterson", role: "Member" },
    { name: "Anthony Murphy", role: "Member" },
    { name: "Andrew Piel", role: "Member" },
    { name: "Andy Adams", role: "Chief School Administrator" },
    { name: "Pastor Siebert", role: "LCMS Pastor" }
  ];

function mapDoc(id: string, data: any): BoardMember {
  return {
    id,
    name: String(data?.name ?? ""),
    role: String(data?.role ?? ""),
    bio: String(data?.bio ?? ""),
    imageUrl: String(data?.imageUrl ?? ""),
    email: String(data?.email ?? ""),
    sortOrder: Number(data?.sortOrder ?? 999),
    isPublished: data?.isPublished === true,
  };
}

export async function getBoardMembers(options: { useFallback?: boolean } = {}): Promise<BoardMember[]> {
  if (!db) return options.useFallback === false ? [] : fallbackBoard;
  try {
    const snap = await getDocs(query(collection(db, "publicBoard"), orderBy("sortOrder", "asc"), limit(100)));
    const items = snap.docs.map((item) => mapDoc(item.id, item.data())).filter((item) => item.isPublished);
    return items.length ? items : options.useFallback === false ? [] : fallbackBoard;
  } catch (error) {
    console.warn("[public-web] Failed to load publicBoard", error);
    return options.useFallback === false ? [] : fallbackBoard;
  }
}
